import { csmHubSetupSupportWebsiteResource } from '@jira/router-resources__customer-service-common/src/services/csm-hub-setup-support-website-resource/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { serviceDeskContextResource } from '@atlassian/jira-router-resources-service-desk-context/src/services/index.tsx';
import { serviceDeskAnalyticsContextResource } from '@atlassian/jira-router-resources-service-desk-analytics-context/src/services/index.tsx';
import { helpCenterSettingsSupportWebsiteOverviewRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsSupportWebsiteOverviewRoute.tsx';
import AsyncHelpCenterSettingsSidebar from '@atlassian/jira-navigation-apps-sidebar-help-center-settings/src/async.tsx';

import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { AsyncSupportWebsiteNav } from '@atlassian/jira-horizontal-nav-csm-support-website/src/index.tsx';
import { csmBaseUrlResource } from '@atlassian/jira-router-resources-service-desk-customer-service-csm-base-url/src/services/index.tsx';
import {
	HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
	HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation,
} from './ui/support-website-overview/index.tsx';

export const helpCenterSettingsSupportWebsiteOverviewRouteEntry = createEntry(
	helpCenterSettingsSupportWebsiteOverviewRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.support-website.overview',
		layout: serviceProjectLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.HELP_CENTER_SETTINGS,
			menuId: MENU_ID.HELP_CENTER_SETTINGS,
			sidebar: AsyncHelpCenterSettingsSidebar,
			horizontal: fg('csm_contact_us_rte') ? undefined : AsyncSupportWebsiteNav,
		},

		component: ErrorPagesNotFound,

		entryPoint: () => {
			if (!fg('jcs_master_flag')) {
				return undefined;
			}
			return fg('csm_contact_us_rte')
				? HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation
				: HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint;
		},

		resources: [
			...getServiceDeskNavigationResources(),
			serviceDeskContextResource,
			serviceDeskAnalyticsContextResource,
			csmBaseUrlResource,
			resourceWithCondition(() => fg('csm-onboarding'), csmHubSetupSupportWebsiteResource),
		],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsSupportWebsiteOverviewRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsSupportWebsiteOverviewRouteEntry',
			},

			enabled: true,
		},
	}),
);
